import React from "react";

const marketingRoutes = [
    {
        path: '/marketing/Disturbance',
        component: React.lazy(() => import('./reclamation/Disturbance/Disturbance')),
        accessPageName: 'DISTURBANCE',
    },
    {
        path: '/marketing/Promocode',
        component: React.lazy(() => import('./Promocode')),
        accessPageName: 'PROMOCODESETTINGS',
    },
    {
        path: '/marketing/PromocodeCreate',
        component: React.lazy(() => import('./PromocodeCreate')),
        accessPageName: 'PROMOCODECREATE',
    },
    {
        path: '/marketing/Gifts',
        component: React.lazy(() => import('./Gifts/Gifts')),
        accessPageName: 'PROMOCODECREATE',
    }
];

export default marketingRoutes